module.exports = __webpack_public_path__ + "img/10.6d205f74.png";